console.log('[MAIN] START')
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
console.log('[MAIN] App imported', App)
createRoot(document.getElementById('root')!).render(<App />)
console.log('[MAIN] Render done')
